<div class="w-full h-screen grid grid-cols-2">
  <div class="flex flex-col h-full w-full items-center">
    <div class="flex-1 flex flex-col justify-center items-center w-4/7">

      <div class="flex flex-col self-start">
        <img
          src="assets/images/mesgo-login-image.png"
          alt="Logo"
          class="w-52 h-14 my-8"
        />

        @if (formErrorMessage) {
          <p-message
            fluid
            severity="error"
            icon="pi pi-info-circle"
            styleClass="mb-4 w-full"
            class="w-full flex flex-col">
            <p>Las credenciales ingresadas no son correctas.</p>
            <p>Por favor, vuelva a intentarlo.</p>
            <p class="text-gray-500 text-xs! mt-2">{{ formErrorMessage }}</p>
          </p-message>
        }

        <h1 class="text-3xl font-semibold mb-6 text-left">Ingresa a tu cuenta</h1>
      </div>

      <form [formGroup]="form" class="flex flex-col gap-6 w-full">

        <!-- Email -->
        <div class="flex flex-col">
          <label for="userName">Correo electrónico*</label>
          <input 
            pInputText fluid
            id="userName" 
            formControlName="userName"
            placeholder="Ingrese su correo electrónico"
            [invalid]="isInvalid('userName')"/>
          @if (isInvalid('userName')) {
            @if (form.get('userName')?.errors?.['required']) {
              <p-message severity="error" size="small" variant="simple">
                El campo es obligatorio.
              </p-message>
            }
            @if (form.get('userName')?.errors?.['userName']) {
              <p-message severity="error" size="small" variant="simple">
                La información proporcionada no es un correo electrónico válido.
              </p-message>
            }
          }
        </div>

        <!-- Password -->
        <div class="flex flex-col">
          <label for="password">Contraseña*</label>
          <p-password
            fluid
            id="password" 
            formControlName="password" 
            [toggleMask]="true" 
            [feedback]="false"
            placeholder="Ingrese su contraseña"
            [invalid]="isInvalid('password')"/>
          
          @if (isInvalid('password')) {
            <p-message severity="error" size="small" variant="simple">
              El campo es obligatorio.
            </p-message>
          }
        </div>

        <div class="flex items-center">
          <p-checkbox inputId="rememberMe" [binary]="true" formControlName="rememberMe"/>
          <label for="rememberMe" class="ml-2">Recuérdame</label>
        </div>

        <p-button severity="primary" type="button" (onClick)="onSubmit()" [loading]="isLoading" fluid>
          <span>Iniciar sesión</span>
        </p-button>

        <div class="flex justify-center gap-4">
          <p-button label="¿Ha olvidado la contraseña?" link (onClick)="redirectToRecoverPassword()"/>
        </div>

      </form>
    </div>

    <!-- Footer -->
    <app-footer/>

  </div>

  <div>
    <img src="assets/images/login/background.jpg" class="w-full h-full object-cover" />
  </div>

</div>